const audio = require.context('.', false, /\.mp3$/);
let parseAudio = [];
// console.log( "audio is working" );
let audioObj = [
  {
    id: 'test',
    src: '',
  },
];
audio.keys().forEach((key) => {
  parseAudio.push({ id: key, src: key });
});

// console.log( 'parseAudio', parseAudio );

export default parseAudio;
